export function downloadBase64File({
  contentType,
  content,
  filename,
}: {
  content: string;
  contentType: string;
  filename: string;
}) {
  const url = createFileURL({ content, contentType });
  const link = document.createElement('a');
  link.download = `${filename}`;
  link.href = url;
  link.click();
  window.URL.revokeObjectURL(url);
}

export function createFileURL({
  contentType,
  content,
}: {
  content: string;
  contentType: string;
}): string {
  const pdfContent = atob(content); // Decodifica la stringa base64
  const uint8Array = new Uint8Array(pdfContent.length);
  for (let i = 0; i < pdfContent.length; i++) {
    uint8Array[i] = pdfContent.charCodeAt(i);
  }
  const blob = new Blob([uint8Array], {
    type: contentType,
  });
  return window.URL.createObjectURL(blob);
}

const contentTypeToExtension: Record<string, string> = {
  'text/csv': 'csv',
  'application/json': 'json',
  'text/plain': 'txt',
  'text/html': 'html',
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'application/zip': 'zip',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'audio/mpeg': 'mp3',
  'audio/wav': 'wav',
  'video/mp4': 'mp4',
  'video/x-msvideo': 'avi',
  'application/epub+zip': 'epub',
  'application/x-tar': 'tar',
  'application/x-rar-compressed': 'rar',
  'application/x-7z-compressed': '7z',
  'application/x-bzip2': 'bz2',
  'application/x-gzip': 'gz',
};
